import React from "react"

import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { UtilHelper } from "../../helpers/util.helper"

export const PayerStatusFooterComponent: React.FunctionComponent<
    IPayerStatusFooterComponentProps
> = props => {
    return (
        <footer
            className={`flex flex-col items-start gap-[12px] rounded-[16px] bg-brand-white p-[24px] shadow-sm ${props.className || ""}`}
        >
            <PrimaryText typography="h5">Still having trouble?</PrimaryText>

            <PrimaryText>
                If a payer shows Operational and your requests still fail, the
                cause may be the patient’s details or your setup. Our support
                team can look at it with you.
            </PrimaryText>

            <ButtonElement
                htmlType="button"
                type="primary"
                label="Contact support"
                onClick={UtilHelper.openSupportEmail}
            />
        </footer>
    )
}

interface IPayerStatusFooterComponentProps {
    className?: string
}
